import { axiosXhr } from './axiosXhr';
import { appLogout, REFRESH_TOKEN_FAIL } from './services/logout';
let refreshAccessTokenInterval = null;
const TRIGGER_REFRESH_TOKEN = 5 * 60 * 1000; // 5 minutes

export function activateRefreshAccessToken() {
  refreshAccessTokenInterval = setInterval(
    () => refreshAccessToken(),
    TRIGGER_REFRESH_TOKEN
  );
}

export function deactivateRefreshAccessToken() {
  clearInterval(refreshAccessTokenInterval);
}

function refreshAccessToken() {
  axiosXhr({
    url: '/authentication/refresh',
    method: 'POST',
  }).catch((err) => {
    if (err.status === 401) {
      appLogout(REFRESH_TOKEN_FAIL);
    }
  });
}
